// extracted by mini-css-extract-plugin
export default {"card":"tY-z","carouselContainer":"uY-z","carouselContent":"vY-z"};